/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createGetAddressDetailsResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, serializeGetAddressDetailsRequest, serializeGetAddressDetailsResponse, type ErrorResponse, type GetAddressDetailsRequest, type GetAddressDetailsResponse, type InternalErrorResponse } from '../../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/addresses/details/public
 */
export interface PublicRequestBuilder extends BaseRequestBuilder<PublicRequestBuilder> {
    /**
     * Returns detailed address information for registration flow (rate limited)
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<GetAddressDetailsResponse>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 429 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     * @throws {ErrorResponse} error when the service returns a 503 status code
     */
     post(body: GetAddressDetailsRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<GetAddressDetailsResponse | undefined>;
    /**
     * Returns detailed address information for registration flow (rate limited)
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: GetAddressDetailsRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const PublicRequestBuilderUriTemplate = "{+baseurl}/api/addresses/details/public";
/**
 * Metadata for all the requests in the request builder.
 */
export const PublicRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: PublicRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            429: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            503: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createGetAddressDetailsResponseFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeGetAddressDetailsRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
